module.exports = __webpack_public_path__ + "img/logo-small.7c26fd8b.png";